import getConfig from 'next/config';
const { publicRuntimeConfig } = getConfig();

const COOKIE_DOMAIN = new URL(
  publicRuntimeConfig.CLEARTAX_DOMAIN || 'https://cleartax.in'
).hostname;

export type TgetUTMParam = {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_id?: string;
  utm_ref?: string;
  utm_term?: string;
  utm_adgroup?: string;
  utm_keyword?: string;
};

export const deleteCookie = (cookieToBeDeleted: string): void => {
  document.cookie = `${cookieToBeDeleted}=;path=/;max-age=0`;
};

export const setSessionCookie = (name: string, value: string): void => {
  document.cookie = `${name}=${value};path=/;domain=${COOKIE_DOMAIN}`;
};

export const getCookie = (cookieName: string): string => {
  const name = cookieName + '=';
  const allCookieArray = document.cookie.split(';');

  const cookie = allCookieArray.find(
    (cookieValue) => cookieValue.trim().indexOf(name) === 0
  );

  return cookie ? cookie.substring(name.length + 1, cookie.length) : '';
};

export const setUTMParamInCookie = (
  query: string | Record<string, string>
): void => {
  const cookieNamePrefix = 'ct_';
  const queryParams = new URLSearchParams(query);
  const hasUtmParams = Object.values(UTMNaming).some((param) =>
    queryParams.has(param)
  );
  const onlyUtmRefPresent =
    queryParams.get(UTMNaming.ref as string) !== null &&
    Object.values(UTMNaming).every(
      (param) => param === UTMNaming.ref || !queryParams.has(param)
    );

  if (!hasUtmParams) return;

  Object.values(UTMNaming).forEach((param) => {
    if (onlyUtmRefPresent && param !== UTMNaming.ref) return;

    const value = queryParams.get(param) || '';
    const cookieName = cookieNamePrefix + param;
    deleteCookie(cookieName);
    setSessionCookie(cookieName, value);
  });
};

const UTMNaming: Record<string, string> = {
  source: 'utm_source',
  medium: 'utm_medium',
  campaign: 'utm_campaign',
  content: 'utm_content',
  id: 'utm_id',
  ref: 'utm_ref',
  term: 'utm_term',
  adgroup: 'utm_adgroup',
  keyword: 'utm_keyword',
};

export const getUTMParameters = (): TgetUTMParam => {
  const UTMObject: Record<string, string> = {};
  Object.keys(UTMNaming).forEach((UTMParam) => {
    const cookieValue = getCookie(`ct_${UTMNaming[UTMParam]}`);
    if (cookieValue) UTMObject[UTMNaming[UTMParam] || ''] = cookieValue;
  });
  return UTMObject;
};

export const getHubspotCookie = (): Record<string, string> => {
  return {
    hubspotutk: getCookie('hubspotutk'),
  };
};
